import {
    FETCH_COMBINED_VIEW_DATA_SUCCESS,
    RESET_COMBINED_VIEW_DATA,
    UPDATE_COMBINED_VIEW_DATA_SUCCESS,
    RESET_ALL_COMBINED_VIEW_DATA,
    FETCH_COMBINED_VIEW_FILES_SUCCESS,
    UPDATE_COMBINED_VIEW_FILE_CAPTION,
    REMOVE_PDATA,
    SET_ALL_FILES_FOR_DOWNLOAD,
    FETCH_COMBINED_VIEW_WORKKARD_FILES_SUCCESS,
    UPDATE_COMBINED_VIEW_FILES_SUCCESS,
    FETCH_PRINT_COMBINED_VIEW_DATA_SUCCESS,
    RESET_WORKKARD_DETAIL_DATA,
    RESET_PRINT_COMBINED_VIEW_DATA
} from "../actions/actionConstants";

const initialState = {
    activity: [],
    filters: [],
    settings: {},
    // The timeline page currently held, and the server's count of every entry
    // that matches the active filters. `total` drives the infinite scroll's
    // stop condition, which used to be read off the first row's tot_recs.
    entries: [],
    total: 0,
    files: {},
    workkard: {},
    galleryData: [],
    date: {},
    downloadFileUrls: [],
    workkardFiles: [],
    printData:{},
    cvExcludedFilters:{},
    showAllTemplates: false
}

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_COMBINED_VIEW_DATA_SUCCESS:
            const data = action.payload
            return Object.assign(
                {},
                state,
                data
            );

        case FETCH_COMBINED_VIEW_FILES_SUCCESS:
            const files = action.payload.fileData;
            const galleryImages = action.payload.galleryData;
            const filesObj = Object.assign({}, state.files, files);
            const galleryData = galleryImages.length > 0 ? [].concat(galleryImages, state.galleryData || []) : galleryImages;
            return Object.assign({}, state, { files: filesObj, galleryData: galleryData });

        case UPDATE_COMBINED_VIEW_FILES_SUCCESS:
            const updatedgalleryData = action.payload.galleryData.length > 0 ? [].concat(action.payload.galleryData, state.galleryData || []) : action.payload.galleryData;
            const newfileData = Object.assign({}, state.files, action.payload.fileData);
            return Object.assign({}, state, { files: newfileData, galleryData: updatedgalleryData });

        case RESET_COMBINED_VIEW_DATA:
            const resetdata = {
              activity: state.activity,
              filters: state.filters,
              settings: state.settings,
              users: state.users,
              printData: state.printData,
              downloadFileUrls: state.downloadFileUrls,
              workkardFiles: state.workkardFiles,
              cvExcludedFilters: state.cvExcludedFilters,
              dntids: state.dntids,
              showAllTemplates: state.showAllTemplates
            };
            return Object.assign(
                {},
                initialState,
                resetdata
            );

        case RESET_ALL_COMBINED_VIEW_DATA:
            const resetcvdata = {
              cvExcludedFilters: state.cvExcludedFilters,
              dntids: state.dntids,
            };
            return Object.assign(
                {},
                initialState,
                resetcvdata
            );

        case UPDATE_COMBINED_VIEW_DATA_SUCCESS:
            const newEntries = [].concat(state.entries, action.payload.entries || [])
            const newData = {
                activity: state.activity,
                filters: state.filters,
                settings: state.settings,
                entries: newEntries,
                total: action.payload.total != null ? action.payload.total : state.total,
                date: state.date,
                start: action.payload.start,
                end: action.payload.end
            }
            return Object.assign({}, state, newData)

        case UPDATE_COMBINED_VIEW_FILE_CAPTION:
            const {fid, caption, send_date} = action.payload;
            const bucket = state.files[send_date];
            if (!bucket) {
                return state;
            }
            const rewritten = bucket.map((file) => (
                file.guid === fid ? Object.assign({}, file, { caption: caption }) : file
            ));
            return Object.assign(
                {},
                state,
                { files: Object.assign({}, state.files, { [send_date]: rewritten }) }
            );

        // Entries are removed by their stable server-issued id. The old code
        // filtered on `rn`, a per-page row ordinal, so a removal after the
        // scroll had loaded a second page deleted whichever row happened to
        // share that ordinal.
        case REMOVE_PDATA:
            const removedId = action.payload;
            return Object.assign(
                {},
                state,
                { entries: state.entries.filter((entry) => entry.id !== removedId) }
            );

        case SET_ALL_FILES_FOR_DOWNLOAD:
            return Object.assign(
                {},
                state,
                {downloadFileUrls:action.payload}
            );

        case FETCH_COMBINED_VIEW_WORKKARD_FILES_SUCCESS:
            return Object.assign(
                {},
                state,
                {workkardFiles: action.payload}
            );

        case FETCH_PRINT_COMBINED_VIEW_DATA_SUCCESS:
            return Object.assign(
                {},
                state,
                {printData:action.payload});
        case RESET_WORKKARD_DETAIL_DATA:
            return Object.assign(
                {},
                initialState
            );

        case RESET_PRINT_COMBINED_VIEW_DATA:
            return Object.assign(
                {},
                state,
                {printData:{}});
        default:
            return state;
    }
}
